document.addEventListener('DOMContentLoaded', () => {
  // Form Tabs
  document.querySelectorAll('.form-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.form-tab').forEach(t => t.classList.remove('active'));
      document.querySelectorAll('.form-panel').forEach(p => p.classList.remove('active'));
      
      tab.classList.add('active');
      const panel = document.querySelector(`[data-panel="${tab.dataset.form}"]`);
      if(panel) panel.classList.add('active');

      // Update hidden department field
      const deptField = document.getElementById('contact_dept');
      if (deptField) {
        deptField.value = tab.dataset.form === 'customer' ? 'Customer Query' : 'Business Enquiry';
      }
    });
  });

  // Customer Conditionals
  const customerType = document.getElementById('c-type');
  const customerConditionals = {
    'order':    ['cond-order-number'],
    'defect':   ['cond-order-number', 'cond-photo'],
    'buyback':  ['cond-order-number', 'cond-delivery-date'],
    'hallmark': ['cond-order-number'],
    'sizing':   ['cond-product-type', 'cond-measurement'],
    'custom':   ['cond-budget'],
    'other':    []
  };

  function updateCustomerConditionals() {
    if (!customerType) return;
    const val = customerType.value;
    const allConds = ['cond-order-number','cond-delivery-date','cond-product-type','cond-measurement','cond-budget','cond-photo'];
    
    allConds.forEach(id => {
      const el = document.getElementById(id);
      if (el) el.classList.remove('visible');
    });

    if (customerConditionals[val]) {
      customerConditionals[val].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.classList.add('visible');
      });
    }
  }

  if(customerType) {
    customerType.addEventListener('change', updateCustomerConditionals);
    // Initial run
    updateCustomerConditionals();
  }

  // Business Conditionals
  const businessType = document.getElementById('b-type');
  function updateBusinessConditionals() {
    if (!businessType) return;
    const val = businessType.value;
    const platform = document.getElementById('cond-platform');
    const reach = document.getElementById('cond-reach');
    const pub = document.getElementById('cond-publication');

    [platform, reach, pub].forEach(el => el && el.classList.remove('visible'));

    if (val === 'influencer' || val === 'collab') {
      platform && platform.classList.add('visible');
      reach && reach.classList.add('visible');
    } else if (val === 'press' || val === 'styling') {
      pub && pub.classList.add('visible');
    }
  }

  if(businessType) {
    businessType.addEventListener('change', updateBusinessConditionals);
    // Initial run
    updateBusinessConditionals();
  }

  // File Upload Label
  const photoInput = document.getElementById('c-photos');
  if(photoInput) {
    photoInput.addEventListener('change', function() {
      const wrap = document.getElementById('fileUploadWrap');
      if(!wrap) return;
      const count = this.files.length;
      const title = wrap.querySelector('.file-upload-title');
      if(title) title.textContent = count > 0 ? `${count} file${count > 1 ? 's' : ''} selected` : 'Attach clear photographs';
    });
  }
});
